import React, { useState, useRef, useEffect } from 'react';
import { Send, Smile, MoreHorizontal, Check, CheckCheck } from 'lucide-react';

const TeamChat = ({ patientId }) => {
  const [messages, setMessages] = useState([
    {
      id: 1,
      sender: 'User 1',
      text: 'with our free* all-in-one communication app.',
      timestamp: 'Thursday 12:02am',
      isOwnMessage: false,
      avatar: '1'
    },
    {
      id: 2,
      sender: 'You',
      text: 'Make one for me also.. ❤️',
      timestamp: 'Thursday 12:02am',
      isOwnMessage: true,
      status: 'read'
    },
    {
      id: 3,
      sender: 'User 1',
      text: "Can't wait for our online baking class tonight 😊",
      timestamp: 'Thursday 12:02am',
      isOwnMessage: false,
      avatar: '1'
    },
    {
      id: 4,
      sender: 'You',
      text: "I'm all prepared",
      timestamp: 'Thursday 12:02am',
      isOwnMessage: true,
      status: 'read'
    }
  ]);
  
  const [newMessage, setNewMessage] = useState('');
  const [isTyping, setIsTyping] = useState(true);
  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const handleSendMessage = () => {
    if (newMessage.trim()) {
      const message = {
        id: messages.length + 1,
        sender: 'You',
        text: newMessage,
        timestamp: new Date().toLocaleString('en-US', { 
          weekday: 'long', 
          hour: 'numeric', 
          minute: '2-digit',
          hour12: true 
        }),
        isOwnMessage: true,
        status: 'sent'
      };
      setMessages([...messages, message]);
      setNewMessage('');
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };

  // Estilos CSS en línea para no depender de Tailwind
  const styles = {
    chatContainer: {
      backgroundColor: 'white',
      borderRadius: '8px',
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
      border: '1px solid #e5e7eb',
      overflow: 'hidden'
    },
    header: {
      backgroundColor: 'white',
      borderBottom: '1px solid #f3f4f6',
      padding: '12px 16px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    messagesContainer: {
      height: '320px',
      overflowY: 'auto',
      backgroundColor: '#f9fafb',
      padding: '16px'
    },
    messageGroup: {
      marginBottom: '16px'
    },
    timestampHeader: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '8px'
    },
    avatar: {
      width: '24px',
      height: '24px',
      borderRadius: '50%',
      background: 'linear-gradient(135deg, #60a5fa, #2563eb)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '12px',
      fontWeight: '600',
      color: 'white',
      marginRight: '8px',
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
    },
    timestamp: {
      fontSize: '12px',
      color: '#6b7280',
      fontWeight: '500'
    },
    messageRow: {
      display: 'flex',
      marginBottom: '4px'
    },
    messageRowOwn: {
      display: 'flex',
      justifyContent: 'flex-end',
      marginBottom: '4px'
    },
    messageBubble: {
      maxWidth: '300px',
      padding: '8px 16px',
      borderRadius: '16px',
      boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
    },
    messageBubbleOther: {
      backgroundColor: 'white',
      color: '#374151',
      border: '1px solid #f3f4f6',
      borderBottomLeftRadius: '4px',
      marginLeft: '32px'
    },
    messageBubbleOwn: {
      backgroundColor: '#3b82f6',
      color: 'white',
      borderBottomRightRadius: '4px'
    },
    messageText: {
      fontSize: '14px',
      lineHeight: '1.4',
      margin: 0
    },
    ownMessageInfo: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      marginTop: '4px',
      marginRight: '8px'
    },
    ownTimestamp: {
      fontSize: '12px',
      color: '#9ca3af',
      marginRight: '4px'
    },
    typingIndicator: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '16px'
    },
    typingAvatar: {
      width: '24px',
      height: '24px',
      borderRadius: '50%',
      background: 'linear-gradient(135deg, #9ca3af, #6b7280)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '12px',
      fontWeight: '600',
      color: 'white',
      marginRight: '8px'
    },
    typingBubble: {
      backgroundColor: 'white',
      border: '1px solid #f3f4f6',
      borderRadius: '16px',
      borderBottomLeftRadius: '4px',
      padding: '12px 16px',
      boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
      marginLeft: '8px'
    },
    typingDots: {
      display: 'flex'
    },
    dot: {
      width: '8px',
      height: '8px',
      backgroundColor: '#9ca3af',
      borderRadius: '50%',
      marginRight: '4px',
      animation: 'bounce 1.4s infinite ease-in-out'
    },
    inputArea: {
      backgroundColor: 'white',
      borderTop: '1px solid #f3f4f6',
      padding: '16px'
    },
    inputRow: {
      display: 'flex',
      alignItems: 'center'
    },
    emojiBtn: {
      background: 'none',
      border: 'none',
      color: '#9ca3af',
      padding: '4px',
      borderRadius: '50%',
      cursor: 'pointer',
      marginRight: '12px',
      transition: 'all 0.2s'
    },
    inputWrapper: {
      flex: 1,
      marginRight: '12px'
    },
    input: {
      width: '100%',
      padding: '10px 16px',
      backgroundColor: '#f9fafb',
      border: '1px solid #d1d5db',
      borderRadius: '25px',
      outline: 'none',
      fontSize: '14px',
      transition: 'all 0.2s'
    },
    sendBtn: {
      padding: '10px',
      borderRadius: '50%',
      border: 'none',
      background: 'linear-gradient(135deg, #f97316, #dc2626)',
      color: 'white',
      cursor: 'pointer',
      boxShadow: '0 2px 4px rgba(249, 115, 22, 0.3)',
      transition: 'all 0.2s',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    sendBtnDisabled: {
      padding: '10px',
      borderRadius: '50%',
      border: 'none',
      backgroundColor: '#e5e7eb',
      color: '#9ca3af',
      cursor: 'not-allowed',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  };

  return (
  

      <div className="p-4 bg-white h-100 rounded-10 shadow-sm">

        <h3 className="mb-3" style={{ fontSize: '1.125rem' }}>Team Chat</h3>
     

        {/* Messages Container */}
        <div style={styles.messagesContainer}>
          {messages.map((message, index) => {
            const showTimestamp = index === 0 || 
              messages[index - 1].sender !== message.sender || 
              messages[index - 1].timestamp !== message.timestamp;

            return (
              <div key={message.id} style={styles.messageGroup}>
                {/* Timestamp header */}
                {showTimestamp && !message.isOwnMessage && (
                  <div style={styles.timestampHeader}>
                    <div style={styles.avatar}>
                      {message.avatar || message.sender.charAt(0)}
                    </div>
                    <span style={styles.timestamp}>
                      {message.timestamp}
                    </span>
                  </div>
                )}

                {/* Message bubble */}
                <div style={message.isOwnMessage ? styles.messageRowOwn : styles.messageRow}>
                  <div style={{
                    ...styles.messageBubble,
                    ...(message.isOwnMessage ? styles.messageBubbleOwn : styles.messageBubbleOther)
                  }}>
                    <p style={styles.messageText}>{message.text}</p>
                  </div>
                </div>

                {/* Own message timestamp and status */}
                {message.isOwnMessage && (
                  <div style={styles.ownMessageInfo}>
                    <span style={styles.ownTimestamp}>
                      {message.timestamp}
                    </span>
                    <div style={{ color: '#3b82f6' }}>
                      {message.status === 'read' ? (
                        <CheckCheck size={12} />
                      ) : (
                        <Check size={12} />
                      )}
                    </div>
                  </div>
                )}
              </div>
            );
          })}
          
          {/* Typing indicator */}
          {isTyping && (
            <div style={styles.typingIndicator}>
              <div style={styles.typingAvatar}>U</div>
              <div style={styles.typingBubble}>
                <div style={styles.typingDots}>
                  <div className="dot" style={styles.dot}></div>
                  <div className="dot" style={styles.dot}></div>
                  <div className="dot" style={styles.dot}></div>
                </div>
              </div>
            </div>
          )}
          
          <div ref={messagesEndRef} />
        </div>

        {/* Input Area */}
        <div style={styles.inputArea}>
          <div style={styles.inputRow}>
            <button className="emoji-btn" style={styles.emojiBtn}>
              <Smile size={18} />
            </button>
            
            <div style={styles.inputWrapper}>
              <input
                type="text"
                value={newMessage}
                onChange={(e) => setNewMessage(e.target.value)}
                onKeyPress={handleKeyPress}
                placeholder="Ask me anything"
                className="input-focus"
                style={styles.input}
              />
            </div>
            
            <button 
              onClick={handleSendMessage}
              disabled={!newMessage.trim()}
              className="send-btn"
              style={newMessage.trim() ? styles.sendBtn : styles.sendBtnDisabled}
            >
              <Send size={16} />
            </button>
          </div>
        </div>

      </div>
      
  
  );
};

export default TeamChat;